/**
 * @tb/ui — shared design system exports.
 *
 * AppShell component (React/Next.js client component) lives in src/AppShell.tsx
 * CSS lives in src/globals.css
 * Tailwind preset in tailwind.config.ts
 * shadcn/ui components in src/components/ui/
 */

// ── App Shell ──────────────────────────────────────────────────
export { SharedAppShell, getIcon } from './AppShell';
export type { ShellConfig, NavItem, NavGroup, NavLeaf } from './AppShell';

// ── shadcn/ui Components ───────────────────────────────────────
export { Button, buttonVariants, type ButtonProps } from './components/ui/button';
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from './components/ui/card';
export { Badge, badgeVariants, type BadgeProps } from './components/ui/badge';
export { Input, type InputProps } from './components/ui/input';
export { Label } from './components/ui/label';
export { Textarea, type TextareaProps } from './components/ui/textarea';
export { Separator } from './components/ui/separator';
export { Skeleton } from './components/ui/skeleton';
export { Progress } from './components/ui/progress';
export {
  Dialog, DialogTrigger, DialogContent, DialogHeader, DialogFooter,
  DialogTitle, DialogDescription, DialogClose,
} from './components/ui/dialog';
export { Tabs, TabsList, TabsTrigger, TabsContent } from './components/ui/tabs';
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './components/ui/tooltip';
export {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuSeparator,
  DropdownMenuGroup, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
} from './components/ui/dropdown-menu';
export {
  Select, SelectGroup, SelectValue, SelectTrigger, SelectContent,
  SelectLabel, SelectItem, SelectSeparator,
} from './components/ui/select';
export { Checkbox } from './components/ui/checkbox';
export { Switch } from './components/ui/switch';
export { ScrollArea, ScrollBar } from './components/ui/scroll-area';
export {
  Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption,
} from './components/ui/table';
export { Avatar, AvatarImage, AvatarFallback } from './components/ui/avatar';
export {
  Sheet, SheetTrigger, SheetContent, SheetHeader, SheetTitle, SheetDescription,
} from './components/ui/sheet';

// ── Utils ──────────────────────────────────────────────────────
export { cn } from './lib/utils';

// ── Error Reporting ────────────────────────────────────────────
export { reportClientError } from './error-reporter';
